import PdaTitle from '../../component/common/PdaTitle'
import React, { useState } from 'react'
import { TabPanel, TabView } from 'primereact/tabview'
import PdaIconTabHeader from '../../component/common/PdaIconTabHeader'
import LocationScan from '../../component/inventory/locationScan'
import AbrogationExpectedLocation from '../../component/location/AbrogationExpectedLocation'
import { useTranslation } from 'react-i18next'
import { tokens } from 'locales/tokens'

const InventoryList = () => {
    const { t } = useTranslation()
    const [activeIndex, setActiveIndex] = useState<number>(0)
    return (
        <div>
            <PdaTitle title={t(tokens.inventory.inventory_inquiry)} historyBack goToHome />
            <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} pt={{ panelContainer: { className: 'p-2' } }}>
                <TabPanel header={<PdaIconTabHeader icon="pi-home" title={t(tokens.inventory.location_scan)} />}>
                    {activeIndex === 0 ? <LocationScan /> : null}
                </TabPanel>
                <TabPanel header={<PdaIconTabHeader icon="" title={t(tokens.inventory.scheduled_disposal_location)} />}>
                    {activeIndex === 1 ? <AbrogationExpectedLocation /> : null}
                </TabPanel>
            </TabView>
        </div>
    )
}

export default InventoryList
